import { partnerComplianceApi } from 'onboarding/api/partnerComplianceApi'
import { ISavePartnerComplianceProps } from 'onboarding/classes/models/partnerCompliance'

class PartnerComplianceService {
  public save(props: ISavePartnerComplianceProps, token: string) {
    return partnerComplianceApi.save(props, token)
  }
}

export const partnerComplianceService = new PartnerComplianceService()
